import { Login } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { useCallback } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { Table } from "../../components/Table";
import { listBi } from "../../services/bi";
import { useStyles } from "./styles";

export function BI() {
  const navigate = useNavigate();
  const styles = useStyles();

  const bi = useQuery("bi", listBi);

  const handleNavigateToDetails = useCallback(
    (item: any) => {
      navigate(`${item.id_submenu_pai}`, { state: item });
    },
    [navigate]
  );

  return (
    <>
      <div className={styles.root}>
        <Typography variant="h4">Visões personalizadas</Typography>
      </div>
      <Paper className={styles.paper}>
        <Table
          toolbar={false}
          data={bi.data as []}
          isLoading={bi.isFetching}
          columns={[
            { title: "#ID", field: "id_submenu_pai" },
            { title: "Nome", field: "name" },
            {
              title: "Ações",
              align: "center",
              render: (row) => (
                <Tooltip title="Acessar" placement="top">
                  <IconButton onClick={() => handleNavigateToDetails(row)}>
                    <Login />
                  </IconButton>
                </Tooltip>
              ),
            },
          ]}
          options={{
            actionsColumnIndex: -1,
            pageSize: 5,
            selectionProps: () => ({
              color: "primary",
            }),
          }}
        />
      </Paper>
    </>
  );
}
